import { swRequest } from "@sourcewhale/shared/src/svelte/api/sw-request";

export const customizeNotetakerBot = (body) =>
  swRequest({
    path: "/api/notetaker/customize_bot",
    method: "POST",
    body,
  });

export const updateNotetakerJoinSettings = (body) =>
  swRequest({
    path: "/api/notetaker/update_join_settings",
    method: "POST",
    body,
  });

export const updateNotetakerLanguageSettings = (body) =>
  swRequest({
    path: "/api/notetaker/update_language_settings",
    method: "POST",
    body,
  });
